import { Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { ROUTES } from "src/constants";
import PatientSelfSchedulingContextProvider from "src/hooks/patient_scheduling/usePatientSelfSchedulingContext";
import { useLobbiePatient } from "src/hooks/patients/useLobbiePatient";
import { logDev } from "src/utils";
import PatientRemoteCareConversion from "../pages/patients/scheduling/PatientRemoteCareConversion";
import PatientScheduling from "../pages/patients/scheduling/PatientScheduling";
import PatientHeader from "../patients/PatientHeader";
import PatientHome from "../patients/PatientHome";
import PatientProfile from "../patients/PatientProfile";
import PatientAppointment from "../patients/appointments/PatientAppointment";
import FullScreenLoadingSpinner from "../shared/loading/FullScreenLoadingSpinner";
import ForgotPassword from "../shared/user/ForgotPassword";
import ResetPassword from "../shared/user/ResetPassword";

// const PatientSchedulingRouter = lazy(() => retry(() => import("./PatientSchedulingRouter")));

const PatientParentRouter: React.FC = () => {
    logDev("PatientParentRouter.load");

    const [user, setUser] = useLobbiePatient();

    return (
        <Suspense
            fallback={<FullScreenLoadingSpinner message={["Loading Lobbie for Patients..."]} />}
        >
            <div className="container">
                <Route path={ROUTES.patientHome}>
                    <PatientHeader />
                    <Switch>
                        <Route exact path={ROUTES.patientHome}>
                            <PatientHome />
                        </Route>
                        <Route exact path={ROUTES.patientProfile}>
                            <PatientProfile user={user} setUser={setUser} />
                        </Route>
                        <Route exact path={ROUTES.patientAppointment()}>
                            <PatientAppointment />
                        </Route>
                    </Switch>
                </Route>
                <Route path={ROUTES.patientSchedulingHome}>
                    <PatientSelfSchedulingContextProvider>
                        <PatientScheduling />
                    </PatientSelfSchedulingContextProvider>
                </Route>
                <Route path={ROUTES.patientConversionHome}>
                    <PatientRemoteCareConversion />
                </Route>

                <Route path={ROUTES.forgotPassword} exact={true}>
                    <ForgotPassword />
                </Route>
                <Route path={ROUTES.resetPassword} exact={true}>
                    <ResetPassword />
                </Route>
            </div>
        </Suspense>
    );
};

export default PatientParentRouter;
